<ng-container [ngSwitch]="templatePart?.Id">

  <ng-container *ngSwitchDefault><div *ngIf="getHtmlFromTemplate(templatePart) as html" [innerHtml]="html | safeHtml"></div></ng-container>

  <ng-container *ngSwitchCase="201"><!--Favorites -->
    <app-favorites-control [itemInfo]="itemInfo" [part]="part" [sci]="sci"></app-favorites-control>
  </ng-container>
  
</ng-container>